export default "__VITE_ASSET__DrXsNFyi__"